import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {ExtensionCategory, RiskAddressedType} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {UserService} from "../../services/user.service";
import {RSValidatorFormDirective} from "../../../libs/rsvalidator/rsvalidator.directive";
import {DataService} from "../../services/data.service";
import invert from "invert-color";
import {ReplaySubject} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-add-risk-type',
  templateUrl: './add-risk-type.component.html',
  styleUrls: ['./add-risk-type.component.scss']
})
export class AddARiskTypeComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  risk: RiskAddressedType = {} as RiskAddressedType;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;

  filteredCategories = new ReplaySubject<ExtensionCategory[]>(1);


  constructor(private userService: UserService, public dataService: DataService) {
    super();

    // Wait for input
    this.dialogValuesUpdated.subscribe(v => {
      this.updateRiskType(v.risk);
    });
    this.updateRiskType({});
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void {
    this.dataService.categories.pipe(
      map(categories => {
        // Get all non-archived categories
        const activeCategories = categories.filter(cat => !cat.archived);

        // If we have a selected category that's archived, add it to the list
        if (this.risk.category) {
          const selectedCategory = categories.find(cat =>
            cat.id === this.risk.category && cat.archived);
          if (selectedCategory) {
            activeCategories.push(selectedCategory);
          }
        }

        return activeCategories;
      })
    ).subscribe(filtered => {
      this.filteredCategories.next(filtered);
    });

  }

  ngOnDestroy() {
    this.filteredCategories.complete();
  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  updateRiskType(input: any) {
    this.risk = {
      id: input.id || null,
      name: input.name || null,
      category: input.category || null
    } as RiskAddressedType;
    console.log('AddRiskType::: ', this.risk);
  }

  close() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  saveRiskType() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.dialogValues.risk = this.risk;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
